import React, { useState, useEffect } from 'react';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import Label from '@/components/form/Label/Label';
import { useSelector, useDispatch } from 'react-redux';
import BlogModule from '@/components/modules/BlogModule/BlogModule';
import HelmetComponent from '@/components/general/Helmet/HelmetComponent';
import './BlogView.scss';

const Blog = (props) => {
  const { blogsDataFromBackend } = props;
  const [hostBlogsModule, setHostBlogsModule] = useState(
    blogsDataFromBackend?.filter((blog) => blog.type_title === 'Anfitrión').slice(0, 4),
  );
  const [spacesBlogsModule, setSpacesBlogsModule] = useState(
    blogsDataFromBackend?.filter((blog) => blog.type_title === 'Espacios').slice(0, 4),
  );
  const [guestsBlogsModule, setGuestsBlogsModule] = useState(
    blogsDataFromBackend?.filter((blog) => blog.type_title === 'Invitados').slice(0, 4),
  );
  const [isShowButtonSeeAllHosts, setIsShowButtonSeeAllHosts] = useState(true);
  const [isShowButtonSeeAllSpaces, setIsShowButtonSeeAllSpaces] = useState(true);
  const [isShowButtonSeeAllGuests, setIsShowButtonSeeAllGuests] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const languageData = useSelector((state) => state.lenguage?.lang);
  const dispatch = useDispatch();

  const esDescription =
    'Explora tendencias de coworking, productividad y trabajo remoto con Popnest. Consejos, inspiración y espacios flexibles para profesionales modernos.';
  const enDescription =
    'Explore coworking trends, productivity tips, and remote work insights with Popnest. Inspiration and flexible spaces for modern professionals.';

  const seeAllHosts = () => {
    setHostBlogsModule(blogsDataFromBackend?.filter((blog) => blog.type_title === 'Anfitrión'));
    setIsShowButtonSeeAllHosts(false);
  };

  const seeSpaces = () => {
    setSpacesBlogsModule(blogsDataFromBackend?.filter((blog) => blog.type_title === 'Espacios'));
    setIsShowButtonSeeAllSpaces(false);
  };

  const seeGuests = () => {
    setGuestsBlogsModule(blogsDataFromBackend?.filter((blog) => blog.type_title === 'Invitados'));
    setIsShowButtonSeeAllGuests(false);
  };
  const handleBlogUpdate = (updatedBlog) => {
    // Actualiza el estado de los módulos correspondientes usando el post_id
    if (updatedBlog.type_title === 'Anfitrión') {
      setHostBlogsModule((prevState) =>
        prevState.map((blog) => (blog.post_id === updatedBlog.post_id ? updatedBlog : blog)),
      );
    } else if (updatedBlog.type_title === 'Espacios') {
      setSpacesBlogsModule((prevState) =>
        prevState.map((blog) => (blog.post_id === updatedBlog.post_id ? updatedBlog : blog)),
      );
    } else if (updatedBlog.type_title === 'Invitados') {
      setGuestsBlogsModule((prevState) =>
        prevState.map((blog) => (blog.post_id === updatedBlog.post_id ? updatedBlog : blog)),
      );
    }
  };

  return (
    <FlexContainer className={'flex-column width100 margb20 blogView'}>
      <HelmetComponent
        title={languageData === 'EN' ? 'Blog - Popnest' : 'Blog - Popnest'}
        description={languageData === 'EN' ? enDescription : esDescription}
        graphTitle={languageData === 'EN' ? 'Blog - Popnest' : 'Blog - Popnest'}
        graphDescription={languageData === 'EN' ? enDescription : esDescription}
      />
      {/*<SearchAccordion className={'margt70 width100'} /> */}
      <FlexContainer className={'flex-column banner width100 items-align-left'}>
        <FlexContainer className={'info-box flex-column align-items-center'}>
          <Label className="text-40 m-text-32 padlr100 m-padlr20">
            <strong>{languageData === 'EN' ? 'Popnest Blog' : 'Blog de Popnest'}</strong>
          </Label>
        </FlexContainer>
        <img src="spaces/spaceslider.png" alt="Foto 1" style={{ width: '100%', height: '500px' }} />
      </FlexContainer>
      <FlexContainer className={'flex-column margt40 padlr50 m-padlr10'}>
        <BlogModule
          blogsData={hostBlogsModule}
          customTitle={
            languageData === 'EN'
              ? 'Popular posts in the Hosts category'
              : 'Entradas populares en la categoría Anfitriones'
          }
          buttonTitle={
            languageData === 'EN' ? 'See All in Hosts Category' : 'Ver más en categoría anfitriones'
          }
          onBlogUpdate={handleBlogUpdate}
          buttonMethod={() => seeAllHosts()}
          isShowButton={hostBlogsModule.length >= 5 ? isShowButtonSeeAllHosts : false}
        />
        {blogsDataFromBackend?.filter((blog) => blog.type_title === 'Espacios').slice(0, 4) && (
          <BlogModule
            blogsData={spacesBlogsModule}
            customTitle={
              languageData === 'EN'
                ? 'Popular posts in the Spaces category'
                : 'Entradas populares en la categoría Espacios'
            }
            buttonTitle={
              languageData === 'EN' ? 'See All Spaces Category' : 'Ver más categoría espacios'
            }
            onBlogUpdate={handleBlogUpdate}
            buttonMethod={() => seeSpaces()}
            isShowButton={blogsDataFromBackend?.filter((blog) => blog.type_title === 'Espacios').length >= 5 ? isShowButtonSeeAllSpaces : false}
          />
        )}

        {blogsDataFromBackend?.filter((blog) => blog.type_title === 'Invitados').slice(0, 4) && (
          <BlogModule
            blogsData={guestsBlogsModule}
            customTitle={
              languageData === 'EN'
                ? 'Popular posts in the Guests category'
                : 'Entradas populares en la categoría Invitados'
            }
            buttonTitle={
              languageData === 'EN' ? 'See All Guests Category' : 'Ver más categoría invitados'
            }
            onBlogUpdate={handleBlogUpdate}
            buttonMethod={() => seeGuests()}
            isShowButton={blogsDataFromBackend?.filter((blog) => blog.type_title === 'Invitados').length >= 5 ? isShowButtonSeeAllGuests : false}
          />
        )}
      </FlexContainer>
    </FlexContainer>
  );
};

export default Blog;
